import Title from "./titel";
import SelectFrame from "./selectFrame";
import { useContext, useEffect, useRef, useState } from "react";
import { getPaintingPrice } from "../../api-route/painting";
import { CartContext } from "../../providers/CartContextProvider";
import { IsInCart, quantityItem } from "../../helper/functions";
import addComma from "../../Functions/numberFormat";
import { Link } from "react-router-dom";
import SelectPasparto from "./SelectPasparto";

const BoxSize = ({ title, value, handler }) => {
    return (<div className="flex flex-col w-full gap-1">
        <span className="text-secondary text-sm">{title} (cm)</span>
        <div className="centerOfParent rounded-md overflow-hidden p-1 border border-secondary">
            <input
                onClick={e => e.target.value = ''}
                type="number"
                className="w-full border-none text-center h-6"
                value={value}
                onChange={handler}
            />
        </div>
    </div>);
};

export default function Aside(
    {
        Painting,
        setMainImage,
        mainImage,
        setWidth,
        passpartout,
        setPasspartout,
        setHeight,
        width,
        height
    }) {
    const { id } = Painting;
    const aspectRatio = Painting.ratio_paintings[0]?.width_ratio_value / Painting.ratio_paintings[0]?.height_ratio_value;

    const { state, dispatch } = useContext(CartContext)

    const widthTimeoutRef = useRef(null);
    const heightTimeoutRef = useRef(null);
    const [frame, setFrame] = useState({ id: null })
    const [price, setPrice] = useState({})
    const [disabled, setDisabled] = useState(false)
    const paint = { ...Painting, size: { width, height }, price, frame, mainImage, passpartout: passpartout }

    useEffect(() => {
        // Clean up timeouts if the component unmounts
        return () => {
            clearTimeout(widthTimeoutRef.current);
            clearTimeout(heightTimeoutRef.current);
        };
    }, []);

    useEffect(() => {
        const get = async () => {
            const data = await getPaintingPrice(id, frame.id, width, height, passpartout)
            setPrice(data?.price ? { price: data.price, frame_price: data.frame_price } : {})
            setHeight(data?.height || height)
            setDisabled(prev => data.error ? true : false)
        }
        get()
    }, [frame.id, id, passpartout])


    const handleWidthChange = (e) => {
        const newWidth = parseInt(e.target.value);
        clearTimeout(widthTimeoutRef.current);
        setWidth(newWidth);
        widthTimeoutRef.current = setTimeout(async () => {
            const newHeight = Math.round(newWidth / aspectRatio);
            setHeight(newHeight);
            const data = await getPaintingPrice(id, frame.id, newWidth, newHeight)
            setPrice(data?.price ? { price: data.price, frame_price: data.frame_price } : {})
            setDisabled(prev => data.error ? true : false)
        }, 1500);
    };

    const handleHeightChange = (e) => {
        const newHeight = parseInt(e.target.value);
        setHeight(newHeight);
        clearTimeout(heightTimeoutRef.current);
        heightTimeoutRef.current = setTimeout(async () => {
            const newWidth = Math.round(newHeight * aspectRatio);
            setWidth(newWidth);
            const data = await getPaintingPrice(id, frame.id, newWidth, newHeight)
            setPrice(data?.price ? { price: data.price, frame_price: data.frame_price } : {})
            setDisabled(prev => data.error ? true : false)
        }, 1500);
    }

    return (<aside className="bg-white border col-span-4 xl:col-span-3 h-fit px-4 py-8 rounded-md text-right ">
        <Title title="لطفا سایز دلخواه را وارد کنید" className='mb-4' />
        <div className="mb-3 text-red-800 text-sm">
            <p dir="auto">- حداقل اندازه مجاز عرض یا ارتفاع ۱۵cm می‌باشد.<br />
                - حداکثر اندازه مجاز عرض یا ارتفاع ۱۱۵cm می‌باشد.</p>
        </div>
        <div className="flex justify-between gap-4 mb-4">
            <BoxSize title="عرض" value={width} handler={handleWidthChange} />
            <BoxSize title="ارتفاع" value={height} handler={handleHeightChange} />
        </div>

        <Title title="لطفا قاب مدنظر را انتخاب کنید" />
        <SelectFrame setFrame={setFrame} setMainImage={setMainImage} id={Painting.id} width={width} />

        <Title title="پاسپارتو" />
        <SelectPasparto setMainImage={setMainImage} passpartout={passpartout} id={Painting.id} frame={frame.id}
            width={width} setPasspartout={setPasspartout} />

        <Title title="قیمت نهایی" />
        <p className="centerOfParent mt-4 flex-row-reverse text-center text-[25px]">
            <div className="">{addComma(price.frame_price ? (price.price) : 0)}</div>
            <span className="mr-3">تومان</span>
        </p>

        <p className="text-center text-[16px] mt-5 mb-3">
            <span className="font-bold">مدت زمان تحویل: </span>
            <span>۵ الی ۷ روز کاری</span>
        </p>

        <div className='centerOfParent flex-col gap-4'>
            {!!price && (IsInCart(state, paint) ? <div
                className='flex items-center py-1 px-2 my-1 mx-2 border border-primary rounded justify-between text-primary'>
                <button className='centerOfParent bg-none border-0 py-2 px-1'>
                    {quantityItem(state, paint) < 2
                        ?
                        <svg className="cursor-pointer"
                            onClick={() => dispatch({
                                type: "REMOVE_ITEM", payload: paint
                            })} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                        :
                        <svg className="cursor-pointer"
                            onClick={() => dispatch({
                                type: "DECREASE", payload: paint
                            })} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    }
                </button>
                <span className='centerOfParent text-xl my-1 mx-3'>{quantityItem(state, paint)}</span>
                <button className="centerOfParent bg-none border-0 py-2 px-1"
                    onClick={() => dispatch({ type: 'INCREASE', payload: paint })}>
                    <svg className="cursor-pointer" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
            </div> : <button onClick={() => dispatch({ type: "ADD_ITEM", payload: paint })} disabled={disabled}
                className="disabled:opacity-50 bg-primary w-full py-3 text-[20px] text-white rounded-lg centerOfParent gap-3">
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path></svg>
                <span>افزودن به سبد خرید</span>
            </button>)}
            {IsInCart(state, paint) && <Link to='/checkout/cart'
                className="disabled:opacity-50 bg-primary w-full py-3 text-[20px] text-white rounded-lg centerOfParent gap-3">
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path></svg>
                <span>رفتن به سبد خرید</span>
            </Link>}
        </div>
    </aside>);
}
